// extracted by mini-css-extract-plugin
module.exports = {"divCard":"event-distribution_divCard_1-nMl","head":"event-distribution_head_3YLFF","text":"event-distribution_text_lCcak","icon":"event-distribution_icon_3o0DQ"};